<tt-page *ngIf="!!edit">
    <a href="" [id]="linkId"></a>

    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="accountingbunt_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="accountingbunt_keyno" [ttModel]="edit.accountingbunt_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="company_name" [ttModel]="edit.company_name" ttReadonly></tt-input>
        <tt-input ttLabel="bunttype" [ttModel]="edit.bunttype" ttReadonly></tt-input>
        <tt-input ttLabel="number_of_invoices" [ttModel]="edit.number_of_invoices" ttReadonly></tt-input>
        <tt-input ttLabel="amount" [ttModel]="edit.amount" ttReadonly></tt-input>
        <tt-input ttLabel="buntvalutacode" [ttModel]="edit.buntvalutacode" ttReadonly></tt-input>
        <tt-checkbox ttLabel="sent_ok" [(ttModel)]="edit.sent_ok"></tt-checkbox>
        <tt-input ttLabel="sent_datetime" [ttModel]="edit.sent_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="bunt_date" [ttModel]="edit.bunt_date" ttReadonly></tt-input>
        <tt-input ttLabel="stockplace_id" [ttModel]="edit.stockplace_id" ttReadonly></tt-input>
        <tt-input ttLabel="bunt_datetime" [ttModel]="edit.bunt_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="registered_of" [ttModel]="edit.registered_of" ttReadonly></tt-input>
        <tt-input ttLabel="modified_datetime" [ttModel]="edit.modified_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="modified_of" [ttModel]="edit.modified_of" ttReadonly></tt-input>
        <tt-button-save ttText="accountingbunt_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>

        <div *ngIf="edit.accountingbunt_errorcode === '-1'">
            <label class="checklist-h2e">{{ edit.accountingbunt_errormessage_alert }}</label>
            <tt-textarea ttLabel="accountingbunt_errormessage" [ttModel]="edit.accountingbunt_errormessage" ttReadonly></tt-textarea>
        </div>

        <div *ngIf="edit.accountingbunt_errorcode === '0'">
            <tt-button
                *ngIf="edit.nbr_of_accountingbuntdata === '0'"
                ttText="accountingbunt_create_accountingbuntdata"
                (ttClick)="createInvoice()"
                [ttSpin]="creatingInvoice"
                ttIcon="fas fa-sync"
            ></tt-button>
            <tt-button
                *ngIf="edit.nbr_of_accountingbuntdata !== '0'"
                ttText="accountingbunt_update_accountingbuntdata"
                (ttClick)="updateInvoice()"
                [ttSpin]="updatingInvoice"
                ttIcon="fas fa-sync"
            ></tt-button>
        </div>

        <tt-button *ngIf="edit.nbr_of_accountingbuntdata !== '0'" ttText="accountingbunt_create_file" (ttClick)="createFile()" [ttSpin]="creatingFile" ttIcon="fas fa-sync"></tt-button>
        <tt-button-goto *ngIf="!!edit.item_state" [ttText]="'accountingbunt_fix'" [ttGoto]="edit.item_state" [ttGotoParms]="edit.item_parms"></tt-button-goto>
        <tt-button-goto
            [ttText]="'accountingbunt_print'"
            [ttGoto]="'selectreport'"
            [ttGotoParms]="{ webpage_name: webPageName, argtype: 'accountingbunt_keyno', argvalue: edit.accountingbunt_keyno }"
        ></tt-button-goto>
        <tt-button-settings *ngIf="edit.show_setting === '1'" ttWebpageName="accountingbunt"></tt-button-settings>
    </ng-container>
</ng-template>
